import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserFormHeader = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Form Header',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          textAlign: 'center',
        },
      },
    },
  },
  render: UserFormHeader,
  fields: {children: TListOfElement},
});

export default config;
